import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import Header from '../Components/header/Header'; // 引入 Header 组件
import Footer from '../Components/footer/Footer'; // 引入 Footer 组件

const Privacy = () => {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#fff' }}>
      <Header />
      <Box 
        sx={{ 
          flex: 1, 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          paddingY: '100px' // 上下间距
        }}
      >
        <Container maxWidth="md">
          <Typography 
            variant="h4" 
            gutterBottom 
            sx={{ 
              fontWeight: 'bold', 
              color: '#000', 
              textAlign: 'center', 
              marginBottom: '40px' 
            }}
          >
            Privacy Policy
          </Typography>

          <Typography variant="body1" paragraph sx={{ color: '#000' }}>
            At Spring Creek, we are committed to protecting your privacy. This privacy policy explains
            how we collect, use, and safeguard your information when you visit our website or use our
            services.
          </Typography>

          <Typography 
            variant="h6" 
            gutterBottom 
            sx={{ fontWeight: 'bold', color: '#000', marginTop: '20px' }}
          >
            1. Information We Collect
          </Typography>
          <Typography variant="body1" paragraph sx={{ color: '#000' }}>
            We may collect personal information such as your name, email address, and contact details
            when you interact with our site or sign up for our services. We also gather non-personal
            information, such as browser type and usage patterns, for analytics purposes.
          </Typography>

          <Typography 
            variant="h6" 
            gutterBottom 
            sx={{ fontWeight: 'bold', color: '#000', marginTop: '20px' }}
          >
            2. Use of Information
          </Typography>
          <Typography variant="body1" paragraph sx={{ color: '#000' }}>
            The information we collect is used to enhance your experience, improve our services, and
            communicate updates or promotional offers. We will not sell or share your personal
            information with third parties without your consent.
          </Typography>

          <Typography 
            variant="h6" 
            gutterBottom 
            sx={{ fontWeight: 'bold', color: '#000', marginTop: '20px' }}
          >
            3. Data Security
          </Typography>
          <Typography variant="body1" paragraph sx={{ color: '#000' }}>
            We implement reasonable security measures to protect your information from unauthorized
            access, disclosure, or alteration. However, no transmission of data over the internet is
            completely secure, and we cannot guarantee the security of your data.
          </Typography>

          <Typography 
            variant="h6" 
            gutterBottom 
            sx={{ fontWeight: 'bold', color: '#000', marginTop: '20px' }}
          >
            4. Changes to This Policy
          </Typography>
          <Typography variant="body1" paragraph sx={{ color: '#000' }}>
            We may update this privacy policy from time to time to reflect changes in our practices or
            legal obligations. We encourage you to review this page periodically for the latest
            information on our privacy practices.
          </Typography>
        </Container>
      </Box>
      <Footer />
    </div>
  );
};

export default Privacy;